import styled from 'styled-components';

export const ButtonImportStyle = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 2px;
  font-family: inherit;
  font-size: ${({ theme }) => {
    return theme.fonts.size.superSmall;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-color: ${({ theme }) => {
    return theme.colors.buttonImportNFe;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  background-color: ${({ theme }) => {
    return theme.colors.backgroundForm;
  }};
  cursor: pointer;

  p {
    margin: 0 0 0 5px;
    color: ${({ theme }) => {
      return theme.colors.buttonImportNFe;
    }};
  }
  transition: background-color 200ms ease-in-out;

  &:hover {
    background-color: ${({ theme }) => {
      return theme.colors.buttonImportNFe;
    }};
    path {
      fill: ${({ theme }) => {
        return theme.colors.backgroundForm;
      }};
    }
    p {
      color: ${({ theme }) => {
        return theme.colors.backgroundForm;
      }};
    }
  }
`;
